import styled from 'styled-components';

import IconInputDel from '../../img/ico_input_del.png';
import IconInputDel2x from '../../img/ico_input_del@2x.png';
import IconSearch from '../../img/ico_search.png';
import IconSearch2x from '../../img/ico_search@2x.png';

const Wrapper = styled.div`
  width: 400px;

  border-bottom: solid 1px #b1b6bb;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

const Input = styled.input`
  width: 100%;

  border: none;

  padding: 11px 12px;

  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;

  &:focus {
    outline: none;
  }
`;

const ImageButtom = styled.img`
  &:hover {
    cursor: pointer;
  }
`;

export default function InputSearch({ value, onChange, onSearch, placeholder, autoFocus }) {
  return (
    <Wrapper>
      <Input
        type="text"
        autoFocus={autoFocus}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onKeyDown={(e) => {
          if (e.code === 'Enter') onSearch(value);
        }}></Input>
      {value && value.length > 0 && (
        <ImageButtom
          width="24px"
          height="24px"
          src={IconInputDel}
          srcSet={IconInputDel2x}
          alt=""
          onClick={() => onChange({ target: { value: '' } })}></ImageButtom>
      )}
      <ImageButtom
        width="32px"
        height="32px"
        src={IconSearch}
        srcSet={IconSearch2x}
        alt=""
        onClick={() => onSearch(value)}></ImageButtom>
    </Wrapper>
  );
}
